import { useState } from "react";
import "./index.css";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import OwnerGridViewComponent from "../../../../components/Accounts/OwnerAccounts/OwnerGridViewComponent";
const OwnerViewAllCard = ({
  data,
  handleRefresh,
  isopen,
  page,
  refreshAllData,
  refreshType,
  setRefreshtype,
  setId,
  total_balance,
  setPrev_Total_balance_state,
  setFailedRefreshId,
  failedRefreshId,
  successRefreshId,
  setSuccessRefreshId,
  currency,
  splitView,
  postiveBalanceData,
  negativeBalanceData,
  refreshAll,
  typepop,
  setIsNeft,
  setIsImps,
  setIsRtgs,
  txnPayLoad,
  setTxnPayLoad,
  handleButtonClick,
  BenEnableNextButton,
  setOpenOwner,
  flow,
  handleViewStatement,
  setStatementId,
  setAccData,
  multiSelect,
  isAssignTagsClicked,
  owneraccountnumberstate,
  setowneraccountnumberstate,
  favouritesFilter,
  popType,
  setpaymentBox,
  type,
  setRefactorAccDetail,
  isLabelClicked,
  selectedLabelsCreate,
  TypeRTGS,
  currentAccountDetails,
  filterRef,
}) => {
  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );

  const [accId, setAccId] = useState("");
  const [prevId, setPrevId] = useState("");
  const [prevBalance, setPrevBalance] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const owneralldata = data;

  const handleClick = (e, id) => {
    if (!isopen) {
      e.stopPropagation();
      handleRefresh(id);
    }
  };

  return (
    <>
      {splitView ? (
        <div className="w-max-content-width mx-auto flex flex-col px-padding-sm">
          <div
            className={`split_view_header pt-padding-md ${
              isopen ? "opacity-light-opacity bg-PopUp-BackDrop" : ""
            }`}
          >
            <div className="w-width-md">
              <p>Positive Balance</p>
            </div>
            <div className="w-width-md pl-padding-lg">
              <p>Negative Balance</p>
            </div>
          </div>
          <div className="flex w-full pt-padding-md">
            <div className="w-width-sm Qmd:w-width-md flex flex-wrap animation_test">
              {postiveBalanceData.length ? (
                <div className="flex flex-wrap gap-gap-sm pb-padding-xl">
                  {postiveBalanceData?.map((account, index) => {
                    return (
                      <div
                        key={account.id}
                        style={{
                          position: "relative",
                        }}
                      >
                        <OwnerGridViewComponent
                          filterRef={filterRef}
                          dispatch={dispatch}
                          navigate={navigate}
                          index={index}
                          account={account}
                          isopen={isopen}
                          page={page}
                          refreshAllData={refreshAllData}
                          refreshType={refreshType}
                          setRefreshtype={setRefreshtype}
                          setId={setId}
                          total_balance={total_balance}
                          setPrev_Total_balance_state={
                            setPrev_Total_balance_state
                          }
                          setFailedRefreshId={setFailedRefreshId}
                          failedRefreshId={failedRefreshId}
                          successRefreshId={successRefreshId}
                          setSuccessRefreshId={setSuccessRefreshId}
                          currency={currency}
                          refreshAll={refreshAll}
                          typepop={typepop}
                          setIsNeft={setIsNeft}
                          setIsImps={setIsImps}
                          setIsRtgs={setIsRtgs}
                          txnPayLoad={txnPayLoad}
                          setTxnPayLoad={setTxnPayLoad}
                          setpaymentBox={setpaymentBox}
                          handleButtonClick={handleButtonClick}
                          BenEnableNextButton={BenEnableNextButton}
                          setOpenOwner={setOpenOwner}
                          flow={flow}
                          handleViewStatement={handleViewStatement}
                          handleClick={handleClick}
                          ownerAccBalanceLoading={ownerAccBalanceLoading}
                          ownerAccBalanceError={ownerAccBalanceError}
                          accId={accId}
                          setAccId={setAccId}
                          setStatementId={setStatementId}
                          setAccData={setAccData}
                          prevId={prevId}
                          setPrevId={setPrevId}
                          prevBalance={prevBalance}
                          setPrevBalance={setPrevBalance}
                          multiSelect={multiSelect}
                          owneraccountnumberstate={owneraccountnumberstate}
                          setowneraccountnumberstate={
                            setowneraccountnumberstate
                          }
                          favouritesFilter={favouritesFilter}
                          isAssignTagsClicked={isAssignTagsClicked}
                          isLabelClicked={isLabelClicked}
                          setRefactorAccDetail={setRefactorAccDetail}
                          type={type}
                          selectedLabelsCreate={selectedLabelsCreate}
                          TypeRTGS={TypeRTGS}
                          currentAccountDetails={currentAccountDetails}
                        />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="noaccountfound">
                  No accounts were found with a positive balance.
                </p>
              )}
            </div>
            <div
              className={`owner_split_div relative top-top-base z-z-index-overlay ${
                isopen ? "opacity-light-opacity bg-PopUp-BackDrop" : ""
              }`}
            />
            <div className="w-width-sm Qmd:w-width-md pl-padding-sm animation_test2">
              {negativeBalanceData.length ? (
                <div className="flex flex-wrap gap-gap-sm pb-padding-xl">
                  {negativeBalanceData?.map((account, index) => {
                    return (
                      <div
                        key={account.id}
                        style={{
                          position: "relative",
                        }}
                      >
                        <OwnerGridViewComponent
                          filterRef={filterRef}
                          dispatch={dispatch}
                          navigate={navigate}
                          index={index}
                          account={account}
                          isopen={isopen}
                          page={page}
                          refreshAllData={refreshAllData}
                          refreshType={refreshType}
                          setRefreshtype={setRefreshtype}
                          setId={setId}
                          total_balance={total_balance}
                          setPrev_Total_balance_state={
                            setPrev_Total_balance_state
                          }
                          setFailedRefreshId={setFailedRefreshId}
                          failedRefreshId={failedRefreshId}
                          successRefreshId={successRefreshId}
                          setSuccessRefreshId={setSuccessRefreshId}
                          currency={currency}
                          refreshAll={refreshAll}
                          typepop={typepop}
                          setIsNeft={setIsNeft}
                          setIsImps={setIsImps}
                          setIsRtgs={setIsRtgs}
                          txnPayLoad={txnPayLoad}
                          setTxnPayLoad={setTxnPayLoad}
                          setpaymentBox={setpaymentBox}
                          handleButtonClick={handleButtonClick}
                          BenEnableNextButton={BenEnableNextButton}
                          setOpenOwner={setOpenOwner}
                          flow={flow}
                          handleViewStatement={handleViewStatement}
                          handleClick={handleClick}
                          ownerAccBalanceLoading={ownerAccBalanceLoading}
                          ownerAccBalanceError={ownerAccBalanceError}
                          accId={accId}
                          setAccId={setAccId}
                          setStatementId={setStatementId}
                          setAccData={setAccData}
                          prevId={prevId}
                          setPrevId={setPrevId}
                          prevBalance={prevBalance}
                          setPrevBalance={setPrevBalance}
                          multiSelect={multiSelect}
                          owneraccountnumberstate={owneraccountnumberstate}
                          setowneraccountnumberstate={
                            setowneraccountnumberstate
                          }
                          favouritesFilter={favouritesFilter}
                          setRefactorAccDetail={setRefactorAccDetail}
                          type={type}
                          selectedLabelsCreate={selectedLabelsCreate}
                          TypeRTGS={TypeRTGS}
                          currentAccountDetails={currentAccountDetails}
                        />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <>
                  <p
                    style={{ paddingLeft: "var(--padding-lg)" }}
                    className={`noaccountfound ${isopen ? "bg-PopUp-BackDrop opacity-light-opacity" : ""}`}
                  >
                    No accounts were found with a negative balance.
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        //  Todo
        <div
          className="standard-card-alignment gap-y-gap-md gap-x-gap-sm "
          style={{
            width: popType === "ownerStatement" ? "95%" : "",
          }}
        >
          {owneralldata?.map((account, index) => {
            return (
              <OwnerGridViewComponent
                filterRef={filterRef}
                dispatch={dispatch}
                navigate={navigate}
                index={index}
                account={account}
                isopen={isopen}
                page={page}
                refreshAllData={refreshAllData}
                refreshType={refreshType}
                setRefreshtype={setRefreshtype}
                setId={setId}
                total_balance={total_balance}
                setPrev_Total_balance_state={setPrev_Total_balance_state}
                setFailedRefreshId={setFailedRefreshId}
                failedRefreshId={failedRefreshId}
                successRefreshId={successRefreshId}
                setSuccessRefreshId={setSuccessRefreshId}
                currency={currency}
                refreshAll={refreshAll}
                typepop={typepop}
                setIsNeft={setIsNeft}
                setIsImps={setIsImps}
                setIsRtgs={setIsRtgs}
                txnPayLoad={txnPayLoad}
                setTxnPayLoad={setTxnPayLoad}
                setpaymentBox={setpaymentBox}
                handleButtonClick={handleButtonClick}
                BenEnableNextButton={BenEnableNextButton}
                setOpenOwner={setOpenOwner}
                flow={flow}
                handleViewStatement={handleViewStatement}
                handleClick={handleClick}
                ownerAccBalanceLoading={ownerAccBalanceLoading}
                ownerAccBalanceError={ownerAccBalanceError}
                accId={accId}
                setAccId={setAccId}
                setStatementId={setStatementId}
                setAccData={setAccData}
                prevId={prevId}
                setPrevId={setPrevId}
                prevBalance={prevBalance}
                setPrevBalance={setPrevBalance}
                multiSelect={multiSelect}
                isAssignTagsClicked={isAssignTagsClicked}
                isLabelClicked={isLabelClicked}
                owneraccountnumberstate={owneraccountnumberstate}
                setowneraccountnumberstate={setowneraccountnumberstate}
                favouritesFilter={favouritesFilter}
                setRefactorAccDetail={setRefactorAccDetail}
                type={type}
                selectedLabelsCreate={selectedLabelsCreate}
                TypeRTGS={TypeRTGS}
                currentAccountDetails={currentAccountDetails}
              />
            );
          })}
        </div>
      )}
    </>
  );
};

export default OwnerViewAllCard;
